import { WORKFLOW_TYPE } from "./WORKFLOW_TYPE";

export const workflowTypeMap = {
  [WORKFLOW_TYPE.COUNTRY_LEVEL]: 'Country level',
  [WORKFLOW_TYPE.LOCATION_LEVEL]: 'Location level',
  [WORKFLOW_TYPE.BUILDING_LEVEL]: 'Building level',
  [WORKFLOW_TYPE.TECHNOLOGY_LEVEL]: 'Technology level',
}